import { formatApprovalReviewPeriod } from '@jms/model';
import { DateTime } from 'luxon';
import { VisitApprovalRecordRef } from './visit.approval.detail.model';

export function formatApprovalPeriod(approval: VisitApprovalRecordRef | null | undefined): string {

  const context = approval?.reviewContext;
  if (!context) return approval?.name || 'Not recorded';
  if (!context.from || !context.to) return context.label || 'Not recorded';
  return formatApprovalReviewPeriod(context) ?? 'Not recorded';
}

/**
 * A saved appointment in the site's own zone, said once: "Tue 1 Sep 2026 · 7:00 AM – 4:00 PM".
 * The zone is named only when it differs from the viewer's, so a local reader is not handed an offset.
 */
export function formatApprovalAppointment(appointment: { startDate: Date | string; endDate: Date | string; allDay?: boolean; timezone: string }, viewerZone = DateTime.local().zoneName): string {
  const start = DateTime.fromJSDate(new Date(appointment.startDate), { zone: appointment.timezone });
  const end = DateTime.fromJSDate(new Date(appointment.endDate), { zone: appointment.timezone });
  if (!start.isValid || !end.isValid) return 'Not recorded';
  const zone = appointment.timezone !== viewerZone ? ` (${appointment.timezone})` : '';
  if (appointment.allDay) return `${start.toFormat('ccc d MMM yyyy')} · All day`;
  if (start.hasSame(end, 'day')) return `${start.toFormat('ccc d MMM yyyy')} · ${start.toFormat('h:mm a')} – ${end.toFormat('h:mm a')}${zone}`;
  return `${start.toFormat('ccc d MMM, h:mm a')} – ${end.toFormat('ccc d MMM yyyy, h:mm a')}${zone}`;
}
